<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22.646"
    height="16.636"
    viewBox="0 0 22.646 16.636"
  >
    <g transform="translate(0 -67.945)">
      <g transform="translate(19.327 67.945)">
        <path
          d="M440.314,71.262h-1.327v-1.99H437V67.945h3.319Z"
          transform="translate(-436.995 -67.945)"
        />
      </g>
      <g transform="translate(0 67.945)">
        <path
          d="M1.327,71.262H0V67.945H3.319v1.327H1.327Z"
          transform="translate(0 -67.945)"
        />
      </g>
      <g transform="translate(19.327 81.264)">
        <path
          d="M440.314,372.4H437V371.07h1.992v-1.99h1.327Z"
          transform="translate(-436.995 -369.08)"
        />
      </g>
      <g transform="translate(0 81.264)">
        <path
          d="M3.319,372.4H0V369.08H1.327v1.99H3.319Z"
          transform="translate(0 -369.08)"
        />
      </g>
      <g transform="translate(2.842 70.503)">
        <path
          d="M64.264,125.792h1.327v11.519H64.264Z"
          transform="translate(-64.264 -125.792)"
        />
      </g>
      <g transform="translate(5.448 70.503)">
        <path
          d="M123.179,125.792h1.327v8.865h-1.327Z"
          transform="translate(-123.179 -125.792)"
        />
      </g>
      <g transform="translate(8.054 70.503)">
        <path
          d="M182.1,125.792h1.327v8.865H182.1Z"
          transform="translate(-182.095 -125.792)"
        />
      </g>
      <g transform="translate(10.659 70.503)">
        <path
          d="M241.01,125.792h1.327v11.519H241.01Z"
          transform="translate(-241.01 -125.792)"
        />
      </g>
      <g transform="translate(13.265 70.503)">
        <path
          d="M299.926,125.792h1.327v11.519h-1.327Z"
          transform="translate(-299.926 -125.792)"
        />
      </g>
      <g transform="translate(18.476 70.503)">
        <path
          d="M417.757,125.792h1.327v11.519h-1.327Z"
          transform="translate(-417.757 -125.792)"
        />
      </g>
      <g transform="translate(15.871 70.503)">
        <path
          d="M358.841,125.792h1.327v8.865h-1.327Z"
          transform="translate(-358.841 -125.792)"
        />
      </g>
      <g transform="translate(5.448 80.695)">
        <path
          d="M123.179,356.234h1.327v1.327h-1.327Z"
          transform="translate(-123.179 -356.234)"
        />
      </g>
      <g transform="translate(8.054 80.695)">
        <path
          d="M182.1,356.234h1.327v1.327H182.1Z"
          transform="translate(-182.095 -356.234)"
        />
      </g>
      <g transform="translate(15.871 80.695)">
        <path
          d="M358.841,356.234h1.327v1.327h-1.327Z"
          transform="translate(-358.841 -356.234)"
        />
      </g>
    </g>
  </svg>
</template>
